import React from 'react';
import { Text, Icon, Box, Flex } from 'core/components';
import OttIcon from 'app/views/serviceProvider/ott/OttIcon';
import ResultMenuItem from './ResultMenuItem';

function OttType({ item, selected, query, onItemClick, ...rest }) {
  const { id, path, name, services } = item;
  return (
    <ResultMenuItem
      {...rest}
      selected={selected}
      onClick={() => onItemClick({ type: 'ott_type', id, path }, 'Search Results')}
    >
      <Flex gridArea="icon" alignItems="center" justifyContent="center">
        <OttIcon type="type" value={name} iconSize={20} />
      </Flex>

      <Box gridArea="title">
        <Text className="title">{name}</Text>
      </Box>

      <Flex gridArea="rightIcon" alignItems="center" justifyContent="center">
        <Icon icon={selected ? 'key-enter' : undefined} color="#ffffff" />
      </Flex>

      <Text
        className="description"
        gridArea="description"
        muted
        small
        whiteSpace="nowrap"
        textOverflow="ellipsis"
        style={{ overflow: 'hidden' }}
      >
        {services.length} Service{services.length > 1 && 's'}
      </Text>
    </ResultMenuItem>
  );
}

export default OttType;
